import React from 'react';

import { CustomNextImage as Image } from '@crehana/next';

import { useTranslation } from '@crehana/i18n';

import { ProfessorsSectionItemProps } from './types';
import {
  ProfessorsItemWrapper,
  ProfessorItemImage,
} from './ProfessorsSectionItem.styles';

const ProfessorsSectionItem: React.FC<
  React.PropsWithChildren<ProfessorsSectionItemProps>
> = ({ professor }) => {
  const { t } = useTranslation();

  return (
    <div className="relative pt-56">
      <ProfessorsItemWrapper className="bg-white pt-48 shadow-card">
        <div className="absolute left-0 w-4 h-40 bg-primary-light" />
        <ProfessorItemImage className="absolute w-80 h-80 top-0 -mt-10 ml-24">
          <Image
            alt={professor.name}
            src={professor.profile}
            layout="fill"
            objectPosition="center"
            objectFit="cover"
          />
        </ProfessorItemImage>
        <div className="mb-16 px-24">
          <h3 className="font-subtitle2">{professor.name}</h3>
          <p className="font-body4 text-base-lighter">
            {t(professor.occupation)}
          </p>
        </div>
        <p className="font-body4 text-gray-main-dark-mode pb-24 px-24">
          {t(professor.bio)}
        </p>
      </ProfessorsItemWrapper>
    </div>
  );
};
export default ProfessorsSectionItem;
